import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'
import { fetchTsIds } from './shared/parallelFetch'
import { useToFill } from './shared/useToFill'

export function useMonthlyData(ghId, year, tsIds) {
  const queryKey = ['monthlyData', ghId, year, tsIds]

  const { data, isLoading, isError, error } = useQuery({
    queryKey,
    queryFn: async () => {
      const monthResp = await fetchTsIds(
        tsIds,
        tsId => api.get(`/sdata_ts?ts_id=${tsId}&gh_id=${ghId}&year_from=${year}&year_to=${year}&stype=MONTH`),
      )
      const yearResp = await fetchTsIds(
        tsIds,
        tsId => api.get(`/sdata_ts?ts_id=${tsId}&gh_id=${ghId}&year_from=${year}&year_to=${year}&stype=YEAR`),
      )
      const result = {
        monthResults: monthResp.map(r => r?.data ?? []),
        yearResults: yearResp.map(r => r?.data ?? []),
      }
      const toFill = [...monthResp, ...yearResp].flatMap(r => r?.to_fill ?? [])
      return { result, toFill }
    },
    enabled: !!ghId && !!year && tsIds.length > 0,
    staleTime: 5 * 60 * 1000,
  })

  // Živé = zobrazený rok je letošní (letos přibývají měsíční/roční agregáty).
  const live = Number(year) === new Date().getUTCFullYear()

  // resp.data je kompletní řada → nahradit prvek dle stype + indexu tsId.
  useToFill(queryKey, data, (result, resp, item) => {
    const i = tsIds.indexOf(item.params?.ts_id)
    if (i < 0) return result
    const bucket = item.params?.stype === 'YEAR' ? 'yearResults' : 'monthResults'
    const next = result[bucket].slice()
    next[i] = resp.data
    return { ...result, [bucket]: next }
  }, { gran: 'MONTH', live })

  const dataMap = {}
  const yearMap = {}
  const dtMap = {}
  const yearDtMap = {}
  if (data?.result) {
    tsIds.forEach((tsId, i) => {
      dataMap[tsId] = {}
      dtMap[tsId] = {}
      ;(data.result.monthResults[i] ?? []).forEach(row => {
        if (row.sid) {
          dataMap[tsId][row.sid] = row.value ?? null
          dtMap[tsId][row.sid] = row.dt ?? null
        }
      })
      const yRows = data.result.yearResults[i] ?? []
      yearMap[tsId]   = yRows.length > 0 ? (yRows[0]?.value ?? null) : null
      yearDtMap[tsId] = yRows.length > 0 ? (yRows[0]?.dt ?? null) : null
    })
  }

  return { dataMap, yearMap, dtMap, yearDtMap, isLoading, isError, error }
}
